import type {Media} from '../../model';
import type {MediaAsset} from '../gallery';

export function toMediaAssets(gallery: Media[]): MediaAsset[] {
  return gallery.map(item => ({
    type: item.type,
    src: item.src,
    poster: item.poster,
    alt: item.alt,
  }));
}
